import * as dateRangePickerActions from "./actions";
import DateRangePicker from "./DateRangePicker";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

const mapStateToProps = (state, ownProps) => {
  return {
    dateFrom: state.scheduleCleaning.dateRangePicker.dateFrom,
    dateTo: state.scheduleCleaning.dateRangePicker.dateTo,
    focusedInput: state.scheduleCleaning.dateRangePicker.focusedInput
  };
};

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(dateRangePickerActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DateRangePicker);



// WEBPACK FOOTER //
// ./src/cleaning/schedule/dateRangePicker/DateRangePickerContainer.js